import { merchantHttp } from './request'

export const merchantApi = {
  // 登录
  login: (data) => merchantHttp.post('/login', data),

  // 总览
  dashboard: (params) => merchantHttp.get('/dashboard', { params: params || {} }),

  // BTC/ETH 参考价（USDT）
  spotPrices: () => merchantHttp.get('/spot-prices'),

  // 订单
  orders: (params) => merchantHttp.get('/orders', { params }),
  cashierOrders: (params) => merchantHttp.get('/cashier-orders', { params }),
  createManualCashierOrder: (data) => merchantHttp.post('/cashier-orders/manual', data),

  // 提现（v1 走 /v1/withdrawals，需 totp_code + 服务端已绑定）
  withdrawals: (params) => merchantHttp.get('/withdrawals', { params }),
  applyWithdraw: (data) => merchantHttp.post('/v1/withdrawals', data),

  /** 谷歌验证器：绑定前生成密钥；v2 客户端无需调用 */
  totpStatus: () => merchantHttp.get('/totp/status'),
  totpSetup: () => merchantHttp.get('/totp/setup'),
  totpBind: (data) => merchantHttp.post('/totp/bind', data),

  // 提现地址（v1：新增/改址走 /v1，需 totp）；列表与删除仍为原路径
  addresses: () => merchantHttp.get('/addresses'),
  addAddress: (data) => merchantHttp.post('/v1/addresses', data),
  updateAddress: (id, data) => merchantHttp.put(`/v1/addresses/${id}`, data),
  delAddress: (id) => merchantHttp.delete(`/addresses/${id}`),

  // API 密钥
  apiKeys: () => merchantHttp.get('/api-keys'),
  createApiKey: (data) => merchantHttp.post('/api-keys', data),
  updateApiKey: (id, data) => merchantHttp.put(`/api-keys/${id}`, data),
  delApiKey: (id) => merchantHttp.delete(`/api-keys/${id}`),

  // Webhook 回调地址
  webhook: () => merchantHttp.get('/webhook'),
  saveWebhook: (data) => merchantHttp.post('/webhook', data),

  userWithdrawalsSummary: () => merchantHttp.get('/user-withdrawals/summary'),
  userWithdrawals: (params) => merchantHttp.get('/user-withdrawals', { params }),
  userWithdrawQuery: (params) => merchantHttp.get('/user-withdrawals/query', { params }),
  createManualUserWithdraw: (data) => merchantHttp.post('/user-withdrawals/manual', data),

  changePassword: (data) => merchantHttp.post('/password', data),
}
